import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { PROPERTY_DATA_SOURCES } from 'legacyGraphQL/constants';

import { getPropertyDetailsAttributeGroups } from 'legacy/utils/property-details';

import { FORM_NAME } from 'legacy/forms/property-explorer-property-details.formconfig';

import { propertyQueryDetailsComplete } from 'actions/property';

import {
  getPropertyShouldLoadPropertyFeatures,
  getPropertyDetails
} from 'selectors/property';
import { getSubjectDefault } from 'selectors/subject';

import conditionallyDispatchAction from 'legacy/hocs/conditionallyDispatchAction';
import addressIdRequired from 'legacy/hocs/addressIdRequired';

import PropertyDetailsSources from 'legacy/components/PropertyDetailsSources';

const { HC, PR, MLS } = PROPERTY_DATA_SOURCES;

const mapStateToProps = (state, ownProps) => {
  const { addressId } = ownProps;
  const subjectDefault = getSubjectDefault(state);
  return {
    shouldDispatchAction:
      getPropertyShouldLoadPropertyFeatures(addressId, HC)(state) ||
      getPropertyShouldLoadPropertyFeatures(addressId, MLS)(state) ||
      getPropertyShouldLoadPropertyFeatures(addressId, PR)(state),
    attributeGroups: getPropertyDetailsAttributeGroups(subjectDefault),
    dataHC: {
      ...getPropertyDetails(addressId, HC)(state),
      quality: subjectDefault.quality
    },
    dataMLS: getPropertyDetails(addressId, MLS)(state),
    dataPR: getPropertyDetails(addressId, PR)(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { addressId } = ownProps;
  return {
    onShouldDispatch: () => dispatch(propertyQueryDetailsComplete(addressId))
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onSubmit: () => dispatchProps.onSubmit(stateProps.changedValues)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(
  reduxForm({
    form: FORM_NAME
  })(addressIdRequired(conditionallyDispatchAction(PropertyDetailsSources)))
);
